import React from 'react';
import { ArrowRight, Star } from 'lucide-react';
export function HeroSection() {
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-12 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-brand-cream to-white overflow-hidden" data-id="element-63">
      <div className="max-w-4xl mx-auto text-center" data-id="element-64">
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-brand-roseLight/30 text-brand-purple font-medium text-sm mb-6" data-id="element-65">
          <Star className="w-4 h-4 text-brand-gold mr-2 fill-current" data-id="element-66" />
          El sistema #1 para dueñas de clínicas de uñas en Argentina
        </div>

        <p className="text-lg sm:text-xl font-semibold text-brand-roseGold mb-4 tracking-wide uppercase" data-id="element-67">
          Conseguí rentabilizar tu negocio ya
        </p>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-brand-purple leading-tight mb-10" data-id="element-68">
          Transformá el Caos de tu Clínica en un{' '}
          <span className="text-brand-roseGold italic" data-id="element-69">Negocio Premium</span> y
          Rentable
        </h1>

        <div className="relative mb-10" data-id="element-70">
          <div className="absolute inset-0 bg-brand-roseGold/20 rounded-full blur-3xl transform scale-90 -z-10" data-id="element-71"></div>
          <img src="https://cdn.magicpatterns.com/uploads/ger4J7oQc75NKAnKVKsYsk/7d4f92e0-dd9c-46ae-a7bf-68f8866f65c3.png" alt="Sistema de Gestión Clínica de Uñas Premium" className="w-full h-auto max-w-2xl mx-auto cursor-pointer transform transition-transform hover:scale-[1.02]" onClick={scrollToPurchase} data-id="element-72" />
        </div>

        <button onClick={scrollToPurchase} className="px-8 py-4 bg-brand-purple hover:bg-brand-purpleLight text-white rounded-lg font-bold text-lg transition-all transform hover:scale-105 shadow-lg inline-flex items-center group" data-id="element-73">
          QUIERO ORGANIZAR MI CLÍNICA HOY
          <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-74" />
        </button>

        <p className="mt-4 text-sm text-gray-500 font-medium" data-id="element-75">
          * Oferta especial con bonos exclusivos válida solo por hoy.
        </p>
      </div>
    </section>;
}